module.exports = __webpack_public_path__ + "img/empty.96e659a2.png";